import { Injectable } from "@angular/core";
import { SignalRConnection } from "ng2-signalr";
import { errorMessages } from "../../settings";
import { CommonService } from "../common.service";
import { WidgethelperService } from "../widgethelper.service";
import { BaseService } from "./base.service";

@Injectable()
export class OrdersByStoreService extends BaseService {

  constructor(
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService
  ) {super(); }

  init(widget: any) {
    this._widgetHelper.CreateHub(widget)
    this.DisplayData(widget);
  }

  DisplayData(widget: any) {
    widget.hub.listenFor("broadcastOrdersByStore").subscribe(
      (result: any) => {
        console.log("broadcastOrdersByStore", result);
        let resultwid;
        let resultcreationtime;
        let lastUpdatedTime;

        if (result && result.length > 0) {
          //console.log(result[0].IsNoDataFound);
          widget.IfNoDataFound = result[0].IsNoDataFound;
          resultwid = result[0].widgetid;
          resultcreationtime = result[0].widgetcreationtime;
          lastUpdatedTime = result[0].LastUpdateTime;
        }
        else {
          widget.errorMessage = errorMessages.noWidgetData;
        }

        if (resultwid == widget.widgetId && resultcreationtime == widget.widgetcreationtime) {
          widget.dataLoaded = false;                 
          widget.errorMessage = null;

          if(widget.IfNoDataFound){
            widget.errorMessage = errorMessages.noWidgetData;
          }else if (widget.IfNoDataFound == null) {
            widget.errorMessage = "Retrieving records. Please wait...";
          }
          else{
            let Report_Periods = [];           
            let orderCount = [];
            let totalUnits = [];
            let unitsPicked = [];

            this.sortArray(result); //sort list

            result.forEach(el => {
              orderCount.push(el.ORDER_COUNT);
              totalUnits.push(el.TOTAL_UNITS);
              unitsPicked.push(el.UNITS_PICKED);
              Report_Periods.push(el.STORE_DESCR);
            });
           
            widget.chartOptions = this.chartOptions();      
            this.addDataSeries(widget.chartOptions, orderCount, 'Order Count', 'bar','a');     
            this.addDataSeries(widget.chartOptions, totalUnits, 'Total Units', 'bar','a');
            this.addDataSeries(widget.chartOptions, unitsPicked, 'Units Picked', 'bar','a');   
            widget.chartOptions.xAxis.data = Report_Periods;            
            widget.chartOptions.xAxis.axisLabel.rotate = 45;
            this.addZoomBar(widget.chartOptions);            
            widget.errorMessage = null;
          }
        }
        widget.dataLoaded = true;
        this._commonService.lastUpdatedTime = lastUpdatedTime;        
      },
      err => {
        console.log("listenFor broadcastOrdersByStore error", err);
      }
    );
  }
  
  remove(widget: any) {
    this._widgetHelper.remove(widget);
  }
  reload(widget: any) {
    this._widgetHelper.reload(widget);
  }

  sortArray(data){
    return data.sort((a, b) => {
      if (a.STORE_DESCR >  b.STORE_DESCR) {
        return 1;
      }
      if (a.STORE_DESCR <  b.STORE_DESCR) {
        return -1;
      }
      return 0;
    }); 
  }

}



// WEBPACK FOOTER //
// ./src/app/services/widgets/orders-by-store.service.ts